import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { DsTabOption, DsTabsOrientation } from '@customdesignsystem';
import { ModalService } from 'src/app/apv/core/services/modal/modal.service';
import { bringModalToFront } from 'src/app/apv/core/utils/functions';
import {
  MULTI_FUNDS_MODAL_TABS,
  MULTI_FUNDS_MODAL_TEXTS,
} from '../../constants/multi-funds-modal.constant';
import { FUND_TAG_VARIANTS } from '../../constants/regime-fund.constant';

const STACKED_TABS_QUERY = '(max-width: 599px)';

@Component({
  selector: 'app-multi-funds-modal',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './multi-funds-modal.component.html',
  styleUrls: ['./multi-funds-modal.component.scss'],
  standalone: false,
})
export class MultiFundsModalComponent implements OnInit, OnDestroy {
  readonly texts = MULTI_FUNDS_MODAL_TEXTS;
  readonly tabs = MULTI_FUNDS_MODAL_TABS;
  readonly tagVariants = FUND_TAG_VARIANTS;
  readonly tabOptions: DsTabOption[] = MULTI_FUNDS_MODAL_TABS.map((tab) => ({
    label: tab.label,
    value: tab.id,
  }));

  activeTab: string = MULTI_FUNDS_MODAL_TABS[0].id;
  tabsOrientation: DsTabsOrientation = 'horizontal';

  private readonly stackedTabsQuery = globalThis.matchMedia?.(STACKED_TABS_QUERY);
  private readonly updateTabsOrientation = (): void => {
    this.tabsOrientation = this.stackedTabsQuery?.matches ? 'vertical' : 'horizontal';
  };

  constructor(
    private readonly modalSvc: ModalService,
    private readonly elementRef: ElementRef<HTMLElement>
  ) {}

  ngOnInit(): void {
    bringModalToFront(this.elementRef.nativeElement);
    this.updateTabsOrientation();
    this.stackedTabsQuery?.addEventListener('change', this.updateTabsOrientation);
  }

  ngOnDestroy(): void {
    this.stackedTabsQuery?.removeEventListener('change', this.updateTabsOrientation);
  }

  get activeContent() {
    return this.tabs.find((tab) => tab.id === this.activeTab) ?? this.tabs[0];
  }

  showTab(tab: string): void {
    this.activeTab = tab;
  }

  closeModal(): void {
    this.modalSvc.closeModal();
  }
}
